import { ApiContext } from "../components/Inventory/context-api";
import * as usersettings from "../components/DeliveryLocation/user-settings";
import { ProductRequest } from "../components/Inventory/ProductInventory/types";

const applyInventoryRules = (
  productElements: NodeListOf<HTMLElement>,
  allInventory: Map<string, number>,
  vendorId: string
) => {
  productElements.forEach((liElement: HTMLElement) => {
    const code = liElement.dataset["productCode"] ?? "";
    const elVendorId = liElement.dataset["vendorId"];
    // if store number is not "ANY" then check inventory.
    if (elVendorId !== vendorId) {
      return;
    }

    liElement.classList.remove("inventory-loading");

    if (allInventory.has(code)) {
      if (allInventory.get(code) === 0) {
        liElement.classList.add("inventory-none");
      }
    } else {
      liElement.classList.add("inventory-loading");
    }
  });
};

const filterProductItems = (
  productElements: NodeListOf<HTMLElement>,
  vendorId: number
) => {
  const productCodes: ProductRequest[] = [];

  productElements.forEach((liElement: HTMLElement) => {
    const code = liElement.dataset["productCode"] ?? "";
    const elVendorId = liElement.dataset["vendorId"];
    // if store number is not "ANY" then check inventory.
    if (elVendorId !== vendorId.toString()) {
      return;
    }

    productCodes.push({ ProductId: 0, UPC: code });
  });

  return productCodes.reverse();
};

const buildInventoryResults = (newInventory: InventoryResult[]) => {
  const allInventory = new Map<string, number>();
  newInventory.forEach((result: InventoryResult) => {
    const prodInventory = result.InventoryInfo;
    for (const key in prodInventory) {
      if (Object.prototype.hasOwnProperty.call(prodInventory, key)) {
        allInventory.set(key, prodInventory[key]);
      }
    }
  });
  return allInventory;
};

/** Filters out party city products that have no inventory.  ONLY Party City products are affected */
async function filterProductList(
  productElements: NodeListOf<HTMLElement>,
  vendorId: number
): Promise<void> {
  const deliveryAddress = usersettings.getDeliveryAddressInfo();

  if (deliveryAddress.LocationId === 0 && !deliveryAddress.PostalCode) {
    console.log("no location selected. ignoring inventory");
    return;
  }

  const productsExist = document.querySelector(
    `[data-vendor-id="${vendorId}"]`
  );
  // for now, we are only applying rules for party city
  if (!productsExist) {
    console.log("no products found, ignoring inventory");
    return;
  }
  try {
    let needsMoreInventory = true;

    do
      while (needsMoreInventory) {
        const newInventory = await ApiContext.getPartialInventory({
          PostalCode: deliveryAddress.PostalCode,
          LocationId: deliveryAddress.LocationId,
          Products: filterProductItems(productElements, vendorId),
          VendorId: vendorId,
        });

        const allInventory = buildInventoryResults([newInventory]);

        applyInventoryRules(
          productElements,
          allInventory,
          vendorId.toString()
        );
        needsMoreInventory = newInventory.HasMoreItems;
      }
    while (needsMoreInventory);
  } catch (e) {
    // fail silently
    console.log('unable to check inventory: ' + e)
  }
}

const productElements = document.querySelectorAll(
  ".product-list > li"
) as NodeListOf<HTMLElement>;

filterProductList(productElements, 103);
